import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchRoleSuccess, fetchRoleError, addRoleSuccess, addRoleError, updateRoleSuccess, updateRoleError, deleteRoleSuccess, deleteRoleError} from '../actions/Role';
import { getDocs, addDoc, updateDoc, deleteDoc } from 'firebase/services/role';
import {FETCH_ROLE, ADD_ROLE, UPDATE_ROLE, DELETE_ROLE} from 'constants/ActionTypes';

function* fetchRoleRequest({ params }) {
  try {
    const fetchedRoleList = yield call(getDocs, { filter: params && params.filter });
    yield put(fetchRoleSuccess(fetchedRoleList));
  } catch (error) {
    console.log(error);
    yield put(fetchRoleError(error));
  }
}

function* addRoleRequest({ payload: { params } }) {
  try {
    const requests = params.map(param => call(addDoc, {data: param}));
    const result = yield all(requests);
    yield put(addRoleSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(addRoleError(error));
  }
}

function* updateRoleRequest({ payload: { params } }) {
  try {
    const result = yield call(updateDoc, {data: params});
    yield put(updateRoleSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(updateRoleError(error));
  }
}

function* deleteRoleRequest({ payload: { params } }) {
  try {
    yield call(deleteDoc, {id: params});
    yield put(deleteRoleSuccess({ id: params }));
  } catch (error) {
    console.log(error);
    yield put(deleteRoleError(error));
  }
}

export function* fetchRole() {
  yield takeEvery(FETCH_ROLE, fetchRoleRequest);
}

export function* addRole() {
  yield takeEvery(ADD_ROLE, addRoleRequest);
}

export function* updateRole() {
  yield takeEvery(UPDATE_ROLE, updateRoleRequest);
}

export function* deleteRole() {
  yield takeEvery(DELETE_ROLE, deleteRoleRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchRole), fork(addRole), fork(updateRole), fork(deleteRole)]);
}
